import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import uploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import PurchaseService from "../../../services/PurchaseOrder";
import UploadFactureFile from "../../../ui/UploadFactureFile";
import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";

const FactureArchived = ({ listFacture }) => {
  const navigate = useNavigate();
  const [inConfirmedFacture, setInConfirmedFacture] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  //   const [clients, setClients] = useState(listFacture);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [factureUploadInformation, setFactureUploadInformation] = useState({
    reference: "any",
    state: 0,
    inConfirmedFacture: inConfirmedFacture,
  });
  const [onUploadFile, setOnUploadFile] = useState(false);
  const [terminedFacture, setTerminedFacture] = useState([]);
  const [archivedFacture, setArchivedFacture] = useState([]);
  const [factureRelatedToInvoice, setFactureRelatedToInvoice] = useState([]);
  const { SearchBar } = Search;
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };

  const onArchiveHandler = (refDocument, isDeleted) => {
    PurchaseService.deleteAndRestoreFacture(refDocument, isDeleted)
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          window.location.reload(false);
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  };

  function buttonDeleteFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn btn-gray-dark btn-sm"
        onClick={() => onArchiveHandler(row.reference, 0)}
      >
        <RestoreFromTrashRoundedIcon />
      </button>
    );
  }

  const onUploadFileHandler = (state, reference, isDeleted) => {
    setFactureUploadInformation({
      reference: reference,
      state: state,
      index: 0,
      factureData: listFacture,
      isDeleted: isDeleted,
    });
    setOnUploadFile(true);
  };
  function buttonFileFormatter(cell, row) {
    if (row.path === "any") {
      return (
        <span>
          <button
            style={{ width: 40 }}
            class="btn bg-gray btn-sm text-center"
            onClick={() =>
              onUploadFileHandler(row.state, row.reference, row.isDeleted)
            }
          >
            <i class="fas fa-plus"></i>
          </button>
        </span>
      );
    } else if (row.path !== "any") {
      return (
        <button
          style={{ width: 40 }}
          class="btn bg-gray btn-sm "
          onClick={() =>
            onShowFileInOtherWizndowHandler(
              // UtilsUrl.sellingFileURL() +
              row.path
            )
          }
        >
          <i class="fas fa-eye"></i>
        </button>
      );
    }
  }

  function buttonDevisFormatter(cell, row) {
    if (row.devisReference === "any") {
      return (
        <span>
          <i class="fas fa-solid fa-ban"></i>
        </span>
      );
    } else if (row.devisReference !== "any") {
      return <span>{row.devisReference}</span>;
    }
  }
  function buttonBDCFormatter(cell, row) {
    if (row.bdcReference === "any") {
      return (
        <span>
          <i class="fas fa-solid fa-ban"></i>
        </span>
      );
    } else if (row.bdcReference !== "any") {
      return <span>{row.bdcReference}</span>;
    }
  }
  const onViewFactureHistoriqueWarehousesHandler = (idDocument) => {
    sessionStorage.setItem("DocumentId", idDocument);
    sessionStorage.setItem("typeDocument", "facture");

    navigate("/historiqueLivraison");
  };
  function buttonLivraisonFormatter(cell, row) {
    if (row.state === 0) {
      return <span className="badge bg-warning">En attente</span>;
    } else if (row.state !== 1) {
      return (
        <a
          onClick={() => {
            onViewFactureHistoriqueWarehousesHandler(row.factureId);
          }}
        >
          <span className="badge bg-primary">En cours</span>{" "}
        </a>
      );
    } else if (row.state !== 2) {
      return (
        <a
          onClick={() => {
            onViewFactureHistoriqueWarehousesHandler(row.factureId);
          }}
        >
          <span className="badge bg-success">Terminé</span>
        </a>
      );
    }
  }

  const onAddTaxHandler = (id) => {
    sessionStorage.setItem("idTax", id);
    sessionStorage.setItem("typeToTax", "Devis");
    navigate("/addTaxAndCharge");
  };
  function buttonChargeFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn bg-gray-dark btn-sm "
        onClick={() => {
          console.log("element", row);
          onAddTaxHandler(row.reference);
        }}
      >
        <i class="fas fa-plus"></i>
      </button>
    );
  }

  const onViewFactureProductsHandler = (refDocument, NoteDocument) => {
    sessionStorage.setItem("refDocument", refDocument);
    sessionStorage.setItem("typeDocument", "facture");

    navigate("/getDocumentByRef");
  };

  function buttonDetailsFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn bg-black btn-sm "
        onClick={() => onViewFactureProductsHandler(row.reference, row.note)}
      >
        <i class="fas fa-shopping-cart"></i>
      </button>
    );
  }
  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connexion");
      });
  };

  const columns = [
    {
      dataField: "reference",
      text: "Réference",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "supplierTitle",
      text: "Fournisseur",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "note",
      text: "Note",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "creationDate",
      text: "DC",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "buyingPrice",
      text: "P.A.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "ttPrice",
      text: "P.A.TT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "devisReference",
      text: "Devis",
      formatter: buttonDevisFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "bdcReference",
      text: "BDC",
      formatter: buttonBDCFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "state",
      text: "Livraison",
      formatter: buttonLivraisonFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "path",
      text: "Fichier",
      formatter: buttonFileFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "factureId",
      text: "Charge",
      formatter: buttonChargeFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "state",
      text: "Info",
      formatter: buttonDetailsFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "isDeleted",
      text: "Restaurer",
      formatter: buttonDeleteFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
  ];

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <div
      className="card card-outline card-dark mb-4"
      style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" }}
    >
      <div className="card-header">
        <h3 className="card-title">Les factures d'achat archivées</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="factureId"
          data={listFacture}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  headerClasses="thead-light"
                  wrapperClasses="table-responsive w-100"
                  striped
                  hover
                  condensed
                  //   expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
      {onUploadFile && (
        <UploadFactureFile
          setOnUploadFile={setOnUploadFile}
          setInConfirmedFacture={setInConfirmedFacture}
          setTerminedFacture={setTerminedFacture}
          setFactureRelatedToInvoice={setFactureRelatedToInvoice}
          factureUploadInformation={factureUploadInformation}
          setArchivedFacture={setArchivedFacture}
        />
      )}
    </div>
  );
};
export default FactureArchived;
